import { Component, OnInit } from '@angular/core';
import { SetupService } from '@core/services/setup';

import { DEPARTMENT_TYPE_CLASSES } from 'src/app/core/constants';

@Component({
  selector: 'app-classes-home',
  templateUrl: './classes-home.component.html',
  styleUrls: ['./classes-home.component.scss']
})
export class ClassesHomeComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Classes
   */
  public departmentType: string = DEPARTMENT_TYPE_CLASSES;

  constructor(public setupService: SetupService) { }

  ngOnInit(): void {
  }

}
